import gql from "graphql-tag";

export const CREATE_APPOINTMENT_HISTORY = gql`
  mutation CreateAppointmentHistory($data: AppointmentHistoryCreateInput!) {
    createAppointmentHistory(data: $data) {
      id
      isDhnAuthorize {
        medicines
      }
      medicinesCodes {
        code
        expirationDate
        startDate
        expiryDate
        isPP
      }
      codes {
        imageCode {
          code
          expirationDate
        }
        labCode {
          code
          expirationDate
          isExternalAnalytics
        }
        licencesCode {
          code
          expirationDate
        }
        opt {
          code
          expirationDate
        }
        refCode {
          code
          expirationDate
        }
        xRayCode {
          code
          expirationDate
        }
      }
    }
  }
`;

export const GET_SIGNATURE_BY_USER_ID = gql`
  query getSignatureByUserId {
    getSignatureByUserId {
      id
      name
      userId
      imgUrl
      mimetype
      createUserId
    }
  }
`;

export const GET_ICD10_CODES = gql`
  query GetICD10Codes($where: ICD10WhereInput!) {
    icd10Codes(where: $where) {
      id
      code
      description
    }
  }
`;

//crea el precio en ars product
export const CREATE_ARS_PRODUCT = gql`
  mutation CreateARSProduct($data: ARSProductCreateInput!) {
    createARSProduct(data: $data) {
      id
    }
  }
`;

export const GET_MEDICINE_PRODUCTS = gql`
  query getMedicinesProduct(
    $where: MedicalAttentionProgramPeriodTypeWhereInput
  ) {
    getMedicinesProduct(where: $where) {
      id
      name
    }
  }
`;

export const GET_LICENSES_WITH_DAYS = gql`
  query getLicensesWithDays {
    getLicensesWithDays {
      id
      name
      description
      days {
        label
        value
      }
    }
  }
`;

export const GET_PATIENT_INFORMATION = gql`
  query GetPatientInformation(
    $ahwhere: AppointmentHistoryWhereInput!
    $pawhere: PatientAllergyWhereInput!
    $pwhere: PatientProgramWhereInput!
    $riwhere: PatientRenalInsufficiencyWhereInput
  ) {
    histories: appointmentsHistories(where: $ahwhere) {
      id
      date
      reason
      diseaseHistory
      diagnosticProcedure
      diagnosticProductId
      imc
      diagnostic {
        code
        description
      }

      medicalStaff {
        name
      }
    }

    patientAllergies(where: $pawhere) {
      allergy {
        id
        name
      }
    }

    programs: patientMedicalAttentionPrograms(where: $pwhere) {
      requestDate
      startingPeriod
      startingPeriodName

      medicalStaff {
        name
      }

      status {
        id
        name
      }

      medicalAttentionProgram {
        id
        name
        dhnConfig
      }
    }

    renalInsufficiencyHistory: getPatientRenalInsufficiencyHistory(
      where: $riwhere
    ) {
      id
      date
      gfr
      rac
      creatinine
      creatinineUnit
      albumin
      albuminUnit
      renalDamageMarker
      stage
      enabled
    }

    renalLatestResults: getPatientLatestRenalInsufficiencyResults(
      where: $riwhere
    ) {
      id
      date
      gfr
      rac
      creatinine
      creatinineUnit
      albumin
      albuminUnit
      renalDamageMarker
      stage
      enabled
    }
  }
`;

export const GET_ARS_PRICE = gql`
  query ArsProduct($where: ARSProductWhereUniqueInput!) {
    arsProduct(where: $where) {
      productId
      amount
      copago
      coverageAmount
      amountPP
      copagoPP
      coverageAmountPP
    }
  }
`;

export const GET_ARS_PRICE_FOR_APPOINTMENT = gql`
  query arsProductForAppointmnet($where: ARSProductWhereUniqueInput!) {
    arsProductForAppointmnet(where: $where) {
      amount
      amountPP
      copago
      copagoPP
      coverageAmount
      coverageAmountPP
      productId
      productTypeId
      coveragePorcent
      coveragePorcentPP
      dietModelId
      dietName
      dietChart

      typeName
      hasPriceRange
      priceRange
      noAsegurado
    }
  }
`;

export const GET_APPOINTMENT_INTERNAL = gql`
  query GetAppointmentInternal(
    $iwhere: ProductWhereInput
    $lwhere: ProductWhereInput
    # $pwhere: ProductWhereInput
    $xwhere: ProductWhereInput
    $cwhere: ProductWhereInput
    $awhere: AllergiesWhereInput!
    # $mmwhere: MedicineWhereInput
    $rfwhere: MedicalStaffWhereInput!
    $mswhere: MedicalStaffWhereUniqueInput!
    $mwhere: MedicalAttentionProgramWhereInput
    $where: AppointmentInternalWhereUniqueInput! # $excludeRelations: Boolean
  ) {
    staff: medicalStaff(where: $mswhere) {
      id
      name
      exequatur
      specialityId

      speciality {
        id
        name
      }
    }

    referrals: medicalStaffs(where: $rfwhere) {
      id
      name
      exequatur
      specialityId

      speciality {
        id
        name
      }
    }

    pams: medicalAttentionPrograms(where: $mwhere) {
      id
      name
      period
      requiredStartingPeriod

      periodType {
        id
        name
      }

      arses {
        id
        name
      }
    }

    allergies: getAllergies(where: $awhere) {
      id
      name
    }

    labExams: getProductsForAppointment(where: $lwhere) {
      id
      name
      productTypeId
      hasFasting
      isExternalAnalytics
      productType {
        id
        individualPrescription
      }
    }

    imgExams: getProductsForAppointment(where: $iwhere) {
      id
      name
      productTypeId
      productType {
        id
        individualPrescription
      }
    }

    xRayExams: getProductsForAppointment(where: $xwhere) {
      id
      name
      productTypeId
      productType {
        id
        individualPrescription
      }
    }

    cardiologyServices: getProductsForAppointment(where: $cwhere) {
      id
      name
      productTypeId
      productType {
        id
        individualPrescription
      }
    }

    # procedures: products(where: $pwhere, excludeRelations: $excludeRelations) {
    #   id
    #   name
    #   diagnosticRequiered
    #   productTypeId
    #   hasITBIS
    #   isDentistry

    #   productType {
    #     id
    #     name
    #     canModifyQuantity
    #     individualPrescription
    #   }

    #   appointmentProducts {
    #     appointmentId
    #   }
    # }

    # medicines: medicines(where: $mmwhere) {
    #   id
    #   name
    # }

    appointment: appointmentInternal(where: $where) {
      id
      appointmentId
      duration
      isDentistry

      height
      weight

      optometry {
        id
        esferaRight
        esferaLeft
        cilindroRight
        cilindroLeft
        ejeRight
        ejeLeft
        adicionLeft
        adicionRight
        eventId
        historyId
        glasses
        pupillaryDistribution
        bifocalHeight
        other
        simpleVision
        progressive
        invisible
        flatTop
        date
      }

      licenses {
        id
        description
        days
        type
        eventId
        historyId
        date
      }

      medicineFilterPam {
        id
        name
        code
        dhnId
        isPP
      }

      options {
        id
        name
        value
        parameterTypeId
      }

      appointmentTabsActive {
        id
        name
        enabled
        tabsId
      }

      pams {
        id
        name
        period
        requiredStartingPeriod
        periodType {
          id
          name
        }
        noApply
      }

      pamPatient {
        id
        name
        prescriptionType
        quantityPrescriptions
      }

      ImgExam {
        id
        name
        imgId
        appointmentId
        expirationDate
        code
        comment
      }

      XRayExam {
        id
        name
        imgId
        appointmentId
        expirationDate
        code
        comment
      }

      LabExam {
        id
        name
        labId
        appointmentId
        expirationDate
        code
      }

      appointmentReferral {
        name
        medicalId
        speciality
        specialityId
        internalReferral
      }

      getAppointmentHistoryProduct {
        id
        date
        productName
        productTypeId
        eventId
        quantity
        diagnosticProductId
        resultProcedures
        conclusionProcedure
        diagnosticProcedure
        diagnosticProcedureName
        patientId
        diagnosticRequiered
        code
        tarifa
        copago
        cobertura
        hasITBIS
        hasPriceRange
        rangePrice
        coberturaPor

        hasPriceChanged
        priceChangedId
        priceChanged
        copagoChanged
        observation
        dicom {
          url
        }
        dietModel {
          id
          name
          dietChart
        }
      }
      appointmentProducts {
        appointmentId
        product {
          id
          name
          diagnosticRequiered
          productTypeId
          hasITBIS
          isDentistry

          dietModel {
            id
            name
            dietChart
          }

          productType {
            id
            name
            canModifyQuantity
            individualPrescription
          }
        }
      }
      center {
        id
        name
        code
        address
        phone
        email
        provinceId
      }

      patient {
        id
        firstName
        middleName
        lastName
        lastName2
        dateOfBirth
        identificationCard
        documentTypeId

        gender {
          id
          name
        }

        ars {
          id
          name
          # dhnConfig
          idDhn
        }
      }

      parameters {
        required
        id
        name
        text
        observation
        minimum
        maximum
        yesOrNo
        maximumAge
        minimumAge
        positiveOrNegative
        unitOfMeasurement

        type {
          id
          name
        }

        groups {
          medicalParameterGroupId
        }
      }

      parameterImc {
        id
        name
        text
        observation
        minimum
        maximum
        yesOrNo
        maximumAge
        minimumAge
        positiveOrNegative
        unitOfMeasurement
        type {
          id
          name
        }
        groups {
          medicalParameterGroupId
        }
      }

      medicalParameterGroups {
        id
        name
      }

      history {
        id
        reason
        diseaseHistory
        nextAppointmentId

        diagnostic {
          id
          code
          description
        }

        diagnostic2 {
          id
          code
          description
        }

        diagnostic3 {
          id
          code
          description
        }

        diagnosticProcedureName {
          id
          code
          description
        }

        appointmentHistoryProduct {
          id
          date
          diagnosticProcedure
          diagnosticProductId
          eventId
          patientId
          conclusionProcedure
          resultProcedure
          quantity
          diagnosticProcedureName {
            # ICD10Code{
            id
            description
            code
            # }
          }

          product {
            id
            name
            diagnosticRequiered
            productTypeId
          }
        }
        parameters {
          id
          eventId
          patientId
          medicalParameterTypeId
          positiveOrNegative
          yesOrNo
          text
          observation
          absolute
          percentage
          medicalParameterId
          appointmentHistoryId
        }

        imageExams {
          id
          name
        }
        event {
          specialityId
          medicalAttentionProgramId
          eventStart
          eventEnd
          details {
            productId
            code
          }
          appointment {
            id
            name
            isDentistry
          }
        }

        laboratoryExams {
          id
          name
        }

        medicines {
          id
          moleculeName
          moleculeCode
          dose
          duration
          medicineId
          startDate
          expiryDate
          total
          frequencyText
          frequency
          note
          isPP

          medicine {
            id
            name
          }
        }

        procedures {
          product {
            id
            name
            diagnosticRequiered
            productTypeId
            hasITBIS
          }
        }

        physicalExam {
          id
          skin
          head
          neck
          heart
          lungs
          abdomen
          upperLimbs
          lowerLimbs
        }
      }
    }
  }
`;

export const SEND_DATA_TO_SANTE = gql`
  query sendDataToSante($data: sendDataToSanteI) {
    sendDataToSante(data: $data)
  }
`;

export const UPDATE_PATIENT_RENAL_DAMAGE_MARKER = gql`
  mutation UpdatePatientRenalDamageMarker(
    $data: UpdatePatientRenalDamageMarkerInput
  ) {
    updatePatientRenalDamageMarker(data: $data)
  }
`;

export const GET_RENAL_PARAMETER_GROUP = gql`
  query GetRenalParameterGroup($where: MedicalParameterGroupWhereUniqueInput!) {
    medicalParameterGroup(where: $where) {
      id
      name
      parameters {
        medicalParameter {
          id
          name
          unitOfMeasurement
          minimum
          maximum
        }
      }
    }
  }
`;

export const GET_PROVINCES = gql`
  query Provinces {
    provinces {
      id
      name
    }
  }
`;

export const GET_MEDS_RNC = gql`
  query GetMedRnc {
    rnc: option(where: { id: "rnc" }) {
      value
    }
    razonSocial: option(where: { id: "name" }) {
      value
    }
  }
`;
